export enum LearningResourseAppNames {
  Knowre = 'Knowre',
  Khan = 'Khan Academy',
  IXL = 'IXL',
  Youtube = 'Youtube',
}
